import React, { Component } from 'react';
import { Button, message, Popconfirm, Table } from 'antd';
import { Link } from 'react-router';

import { queryCustomList, queryDeleteCustom } from '@api/crm/custom';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageSize: 15,
      nowPage: 1,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getCustomList();
  }

  getCustomList = (pageNo, pageSize) => {
    const params = {};
    params.pageNo = pageNo || 1;
    params.pageSize = pageSize || 15;
    queryCustomList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data.result,
          total: res.data.totalCount,
          pageSize: res.data.pageSize,
          nowPage: res.data.pageNo,
        });
      }
    });
  };

  deleteCustom = uuid => {
    const context = this;
    const { nowPage, pageSize } = this.state;
    queryDeleteCustom(uuid).then(res => {
      if (res.statusCode === 200) {
        message.success('删除成功');
        context.getCustomList(nowPage, pageSize);
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '客户名称',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
          <Link to={`/custom/base/edit/${record.uuid}`}>{record.name}</Link>
        ),
      },
      {
        title: '曾用名',
        dataIndex: 'usedName',
        key: 'usedName',
        render: (text, record) => <span>{record.usedName}</span>,
      },
      {
        title: '客户类型',
        dataIndex: 'type',
        key: 'type',
        render: text => (text === 1 ? <span>公司</span> : <span>个人</span>),
      },
      {
        title: '公司官网',
        dataIndex: 'website',
        key: 'website',
        render: (text, record) => <span>{record.website}</span>,
      },
      {
        title: '行业类型',
        dataIndex: 'industry',
        key: 'industry',
        render: (text, record) => <span>{record.industry}</span>,
      },
      {
        title: '联系人姓名',
        dataIndex: 'contactsName',
        key: 'contactsName',
        render: (text, record) => <span>{record.contactsName}</span>,
      },
      {
        title: '联系人电话',
        dataIndex: 'contactsPhone',
        key: 'contactsPhone',
        render: (text, record) => <span>{record.contactsPhone}</span>,
      },
      {
        title: '资金列表',
        dataIndex: 'bill',
        key: 'bill',
        render: (text, record) => <Link to={`/custom/base/${record.uuid}/bill`}>资金列表</Link>,
      },
      {
        title: '公司列表',
        dataIndex: 'company',
        key: 'company',
        render: (text, record) => <Link to={`/custom/base/${record.uuid}/company`}>公司列表</Link>,
      },
      {
        title: '操作',
        key: 'done',
        render: (rext, record) => (
          <span>
            {/* <Link to={`/custom/base/${record.uuid}/billConfig`}>资金关联</Link>
                    <span className="ant-divider"></span>
                    <Link to={`/custom/base/${record.uuid}/companyConfig`}>公司关联</Link>
                    <span className="ant-divider"></span> */}
            <Popconfirm
              onConfirm={() => this.deleteCustom(record.uuid)}
              title="确定删除当前组织吗？"
              placement="topRight"
              overlayStyle={{ width: 200 }}
            >
              <a className="ant-dropdown-link">删除</a>
            </Popconfirm>
          </span>
        ),
      },
    ];
  };

  render() {
    const { data } = this.state;
    const { pageSize, total } = this.state;
    const pagination = {
      total,
      showSizeChanger: true,
      pageSize,
      onShowSizeChange: (current, size) => {
        this.getCustomList(current, size);
      },
      onChange: current => {
        this.getCustomList(current, pageSize);
      },
    };

    return (
      <div>
        <Link to="/custom/base/add">
          <Button type="primary" icon="plus" style={{ marginBottom: 15 }}>
            添加
          </Button>
        </Link>
        <Table
          rowKey="uuid"
          style={{ background: '#fff' }}
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/custom/base/Index.js